import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import ProductsPage from '../../Pages/ProductsPage';
import NoSearchResults from '../../Pages/ProductsPage/ProductsSearched/NoSearchResults';
import SearchResults from '../../Pages/ProductsPage/ProductsSearched/SearchResults';
import ProductTypePage from '../../Pages/ProductTypePage';
import BenefitLayout from '../../layout/layouts/BenefitLayout';
import EmptyLayout from '../../layout/layouts/EmptyLayout';
import { resources } from '../../resources/resources';

export const ProductsRoutes = () => {
  const { t: translations } = useTranslation();
  return (
    <Routes>
      <Route
        path="/:productId"
        element={
          <BenefitLayout>
            <ProductsPage />
          </BenefitLayout>
        }
      />
      <Route
        path="search"
        element={
          <BenefitLayout>
            <SearchResults />
          </BenefitLayout>
        }
      />
      <Route
        path="no-result"
        element={
          <BenefitLayout>
            <NoSearchResults />
          </BenefitLayout>
        }
      />
      <Route
        path="type/:productTypeSlug"
        element={
          <BenefitLayout>
            <ProductTypePage />
          </BenefitLayout>
        }
      />
      <Route
        path="*"
        element={
          <EmptyLayout>
            <p>{translations(resources.notFoundPage)}</p>
          </EmptyLayout>
        }
      />
    </Routes>
  );
};
